import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MenuAppRoutingModule } from "./menu.app-routing.module";

@NgModule({
    imports: [
        CommonModule,
        MenuAppRoutingModule
    ]
})
export class MenuAppModule { }
